// Mock data for Mariam Sallam's Portfolio Website

export const siteConfig = {
  name: "Mariam Sallam",
  tagline: "Cultural Strategist · Global Thought Leader · Visionary",
  email: "mariam@nationalarabinstitute.com",
  secondaryEmail: "mariamsallam05@gmail.com",
  ventureEmail: "mariam@alknzventures.com",
  phone: "+966 056 728 9010",
  location: "Riyadh, Saudi Arabia",
  social: {
    instagram: "https://instagram.com/mariamsallam",
    linkedin: "https://linkedin.com/in/mariamsallam",
    twitter: "https://twitter.com/mariamsallam"
  }
};

export const navLinks = [
  { path: '/', label: 'Home' },
  { path: '/philanthropy', label: 'Philanthropy' },
  { path: '/technology', label: 'Technology' },
  { path: '/speaking', label: 'Speaking & Media' },
  { path: '/contact', label: 'Contact' }
];

export const heroContent = {
  headline: "Bridging Worlds",
  subheadline: "Through Culture & Vision",
  description: "Renowned cultural strategist and thought leader, shaping narratives that connect heritage with the future of global discourse."
};

export const aboutContent = {
  intro: "A visionary at the intersection of culture, strategy, and global influence.",
  bio: [
    "Mariam Sallam is a distinguished cultural strategist whose work transcends boundaries, weaving together the rich tapestry of Arab heritage with contemporary global discourse. With over two decades of experience advising governments, multinational corporations, and cultural institutions, she has established herself as a defining voice in cross-cultural strategy.",
    "Her approach combines deep intellectual rigor with an intuitive understanding of cultural dynamics, enabling her to craft narratives that resonate across diverse audiences while honoring authenticity and heritage.",
    "Based between Dubai and London, Mariam's influence extends across continents, from boardrooms in New York to cultural summits in Riyadh, always carrying forward her mission of elevating Arab voices on the global stage."
  ],
  stats: [
    { number: "20+", label: "Years Experience" },
    { number: "50+", label: "Global Projects" },
    { number: "15", label: "Countries Worked" },
    { number: "100+", label: "Speaking Events" }
  ]
};

export const expertise = [
  {
    title: "Cultural Strategy",
    description: "Developing comprehensive cultural frameworks for organizations seeking authentic engagement with diverse markets and communities."
  },
  {
    title: "Global Advisory",
    description: "Providing strategic counsel to governments and institutions on cross-cultural communication and international positioning."
  },
  {
    title: "Thought Leadership",
    description: "Shaping global conversations through keynotes, publications, and media appearances on culture, identity, and the future of heritage."
  },
  {
    title: "Brand Architecture",
    description: "Creating culturally-resonant brand narratives that honor heritage while speaking to contemporary global audiences."
  }
];

export const workProjects = [
  {
    id: 1,
    title: "Redefining Cultural Narratives",
    client: "Ministry of Culture, Saudi Arabia",
    year: "2024",
    category: "Cultural Strategy",
    description: "Led the strategic development of a comprehensive cultural positioning framework, establishing new paradigms for global cultural diplomacy.",
    image: "https://images.unsplash.com/photo-1720205888671-ec64f89447ed?w=800&q=80"
  },
  {
    id: 2,
    title: "Heritage in Motion",
    client: "Louvre Abu Dhabi",
    year: "2023",
    category: "Brand Architecture",
    description: "Conceptualized and executed the narrative strategy for a landmark exhibition celebrating the intersection of Eastern and Western artistic traditions.",
    image: "https://images.unsplash.com/photo-1653798351701-e9bb54eec90b?w=800&q=80"
  },
  {
    id: 3,
    title: "Voices of Tomorrow",
    client: "World Economic Forum",
    year: "2023",
    category: "Thought Leadership",
    description: "Curated and moderated the flagship cultural dialogue series, bringing together global leaders to discuss the future of cultural preservation.",
    image: "https://images.unsplash.com/photo-1591000507165-38a8a984d942?w=800&q=80"
  },
  {
    id: 4,
    title: "The New Silk Road",
    client: "Dubai Expo 2020",
    year: "2022",
    category: "Global Advisory",
    description: "Strategic advisory for cross-cultural programming, creating experiences that connected 192 nations through shared cultural heritage.",
    image: "https://images.unsplash.com/photo-1491895200222-0fc4a4c35e18?w=800&q=80"
  }
];

export const speakingEvents = [
  {
    title: "The Future of Cultural Identity",
    venue: "TED Global",
    location: "Edinburgh, UK",
    year: "2024"
  },
  {
    title: "Heritage as Strategy",
    venue: "World Economic Forum",
    location: "Davos, Switzerland",
    year: "2024"
  },
  {
    title: "Bridging East & West",
    venue: "Oxford Union",
    location: "Oxford, UK",
    year: "2023"
  },
  {
    title: "Cultural Diplomacy in the Digital Age",
    venue: "United Nations HQ",
    location: "New York, USA",
    year: "2023"
  }
];

export const mediaFeatures = [
  { outlet: "The New York Times", title: "The Voice Reshaping Cultural Diplomacy" },
  { outlet: "Financial Times", title: "Leading the New Wave of Arab Influence" },
  { outlet: "Vogue Arabia", title: "Power & Grace: The Mariam Sallam Story" },
  { outlet: "BBC World Service", title: "Global Conversations" }
];

export const testimonials = [
  {
    quote: "Mariam possesses a rare ability to translate complex cultural dynamics into actionable strategy. Her work has fundamentally transformed how we approach global engagement.",
    author: "Dr. Sarah Mitchell",
    role: "Director, Cultural Affairs",
    organization: "United Nations"
  },
  {
    quote: "Working with Mariam opened our eyes to the depth and power of culturally-informed strategy. She is, without question, the leading voice in this space.",
    author: "James Chen",
    role: "CEO",
    organization: "Global Heritage Foundation"
  }
];

// Mariam's actual photos
export const mariamPhotos = {
  hero: "https://customer-assets.emergentagent.com/job_mariam-editorial/artifacts/i4tbyena_57a2c216-c27c-4203-84f1-f4a5fb86141f.JPG",
  about: "https://customer-assets.emergentagent.com/job_mariam-editorial/artifacts/jmiwoqg0_1398103d-0ba7-4620-a3b3-c613e3875745%202.JPG",
  speaking: "https://customer-assets.emergentagent.com/job_mariam-editorial/artifacts/bahu70lk_57a2c216-c27c-4203-84f1-f4a5fb86141f%202.JPG",
  contact: "https://customer-assets.emergentagent.com/job_mariam-editorial/artifacts/899a7szi_71d0213d-5b38-47b8-8a65-2af6cd0319e5.JPG",
  professional: "https://customer-assets.emergentagent.com/job_mariam-editorial/artifacts/iyhgfbzw_a207aadd-f4b4-4129-a5c7-3723849eec1d%202.JPG"
};

// Cultural art for subtle background textures
export const culturalArt = {
  jerusalem: "https://customer-assets.emergentagent.com/job_8e6f3d30-7f16-4386-b5da-5a8e7275d02e/artifacts/p7iaqjzd_Screen%20Shot%202026-02-09%20at%201.36.58%20PM.png",
  carpet: "https://customer-assets.emergentagent.com/job_8e6f3d30-7f16-4386-b5da-5a8e7275d02e/artifacts/92i91w07_Screen%20Shot%202026-02-09%20at%201.38.44%20PM.png",
  minaret: "https://customer-assets.emergentagent.com/job_8e6f3d30-7f16-4386-b5da-5a8e7275d02e/artifacts/4xyxt3m4_Screen%20Shot%202026-02-09%20at%201.38.07%20PM.png"
};

export const images = {
  architecture1: "https://images.unsplash.com/photo-1720205888671-ec64f89447ed?w=800&q=80",
  architecture2: "https://images.unsplash.com/photo-1653798351701-e9bb54eec90b?w=800&q=80",
  pattern1: "https://images.unsplash.com/photo-1591000507165-38a8a984d942?w=800&q=80",
  geometric: "https://images.unsplash.com/photo-1491895200222-0fc4a4c35e18?w=800&q=80"
};
